import React from 'react';

import 'core-js/es/array/find';
import 'core-js/es/array/find-index';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/string/starts-with';
import 'regenerator-runtime/runtime';
import { assignWith } from 'lodash';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import * as Data from './weborder/Data';
import Weborder from './weborder/index';
import * as MapLoader from './weborder/MapLoader';
import { storage } from './weborder/services/storageServices';
import * as Store from './weborder/Store';
import { Utilities } from './weborder/Utilities';

require.include('file-loader?name=[name].[ext]!./weborder/pwa.html');

function cleanupDeprecated() {
  const deprecatedStorageKeyTester = [
    // disable-local-storage-flipdish-delivery-options : whats the point of storing it when we always request it
    /flipdish-delivery-options/,
    // disable-local-storage-flipdish-restaurant-details : whats the point of storing it when we always request it
    /flipdish-restaurant-details/,
    // disable-local-storage-overflow : json responses r cashed by browser by default
    /\.json$/,
  ];

  for (const key of storage.getKeys()) {
    if (deprecatedStorageKeyTester.some((tester) => tester.test(key))) {
      storage.removeItem(key);
    }
  }
}

function initialiseSettings(options = {}) {
  const currentLanguageInStorage = storage.getItem('flipdish-current-language');

  if (!currentLanguageInStorage) {
    const initialLanguage =
      Utilities.extraOption('data-language') ||
      // used by external embeds
      Utilities.extraOption('data-initial-language');
    if (initialLanguage) {
      Utilities.setInLocalStorage('flipdish-current-language', initialLanguage);
    }
  }

  return assignWith(
    // lowest priority
    {
      baseHref: '/',
      fullScreenOnMobile: 'true',
      initialRoute: false,
      initialScreen: 'delivery-type',
      offset: '0',
      pwa: 'false',
      restaurant: 'system-test-wl',
      server: 'https://api.flipdish.co/',
      includePhysicalRestaurantIds: '',
      theme: 'light',
    },

    {
      restaurant: process.env.REACT_APP_APP_NAME_ID,
    },

    {
      baseHref: Utilities.extraOption('data-base-href'),
      fullScreenOnMobile: Utilities.extraOption('data-full-screen-on-mobile'),
      initialScreen: Utilities.extraOption('data-initial-screen'),
      offset: Utilities.extraOption('data-offset'),
      pwa: Utilities.extraOption('data-pwa'),
      restaurant: Utilities.extraOption('data-restaurant'),
      server: Utilities.extraOption('data-server'),
      includePhysicalRestaurantIds: Utilities.extraOption('data-store-ids'),
      theme: Utilities.extraOption('data-theme'),
    },

    // highest priority
    options,

    // customizer
    (objValue: any, srcValue: any) => {
      return !srcValue ? objValue : srcValue;
    },
  );
}

function createWebOrderStore(settings, initialState = false) {
  const readonly = Utilities.extraOption('data-menuid');

  const storeSettings: Data.Config = {
    DeviceId: Utilities.DeviceId(),
    MapLoader: readonly ? null : MapLoader.LoadMaps(),
    showRestaurantList: settings.initialScreen === 'delivery-type',
    IncludePhysicalRestaurantIds: settings.includePhysicalRestaurantIds,
  };

  const { store } = Store.Init(storeSettings, initialState);
  return store;
}

cleanupDeprecated();

const settings = initialiseSettings();
const store = createWebOrderStore(settings);

if (Utilities.flipdiv) {
  Utilities.flipdiv.classList.add('notranslate');

  render(
    <Provider store={store}>
      <Weborder settings={settings} />
    </Provider>,
    Utilities.flipdiv,
  );
}

(window as any).renderFlipdiv = () => {
  if (Utilities.flipdiv) {
    render(
      <Provider store={store}>
        <Weborder settings={settings} />
      </Provider>,
      Utilities.flipdiv,
    );
  }
};
